import { LayoutBlock } from '@/layout';
import { RouteConfig } from 'vue-router';

const AttendanceRouting: RouteConfig[] = [
    {
        path: 'attendance',
        meta: { title: '考勤' },
        component: LayoutBlock,
        redirect: '/app/attendance/business-calendar',
        children: [
            // 企业日历
            {
                name: 'business-calendar',
                path: 'business-calendar',
                component: () => import('./businessCalendar/businessCalendar.vue'),
                meta: { title: '企业日历' },
            },
        ],
    },
];

export default AttendanceRouting;
